import singleWordReducer from '../reducers/single-word-reducer';
import {RESET_GAME_ACTION, ADD_WORD_ACTION, REMOVE_WORD_ACTION, MARK_WORD_AS_FOUND_ACTION} from '../constants';

const initialState = [
    {
        text: 'words',
        isFound: false,
    },
    {
        text: 'search',
        isFound: false,
    },
    {
        text: 'react',
        isFound: false,
    },
    {
        text: 'game',
        isFound: false,
    },
    {
        text: 'by',
        isFound: false,
    },
    {
        text: 'matti',
        isFound: false,
    },
    {
        text: 'barzeev',
        isFound: false,
    },
];

const wordsReducer = (state = initialState, action) => {
    switch (action.type) {
        case RESET_GAME_ACTION:
            return state.map((word) => {
                word = {...word, isFound: false};
                return word;
            });
        case ADD_WORD_ACTION:
            return [...state, singleWordReducer(state, action)];
        case REMOVE_WORD_ACTION:
            return [...state.slice(0, action.index), ...state.slice(action.index + 1)];
        case MARK_WORD_AS_FOUND_ACTION:
            return state.map((word) => {
                if (word.text === action.word) {
                    word = {...word, isFound: true};
                }
                return word;
            });
        default:
            return state;
    }
};

export default wordsReducer;
